import { PlanType } from '@showbie-socrative/socrative-utils';
import { QueryClient } from '@tanstack/react-query';

import { QUIZ_LIMIT_QUERY_KEY } from '~teacher/hook';
import { updateQuizCount } from '~teacher/hook/useQuizLimit/cacheUpdater/updateQuizCount';
import { proCheck } from '~teacher/util/proCheck';

import { QuizLimit } from '../../../../api/quiz';

export function increaseQuizCount(queryClient: QueryClient, count = 1) {
  const userPlan = proCheck.userPlan();
  if (
    [
      PlanType.FreeLegacy,
      PlanType.Pro,
      PlanType.Complete,
      PlanType.Organization,
      PlanType.Essentials,
    ].includes(userPlan)
  ) {
    return; // pro, or legacy free, we do not care.
  }

  if (count <= 0) return;

  const currentQuizLimit =
    queryClient.getQueryData<QuizLimit>(QUIZ_LIMIT_QUERY_KEY);
  if (!currentQuizLimit) return; // no data to update, we do not care.

  const newQuizCount = currentQuizLimit.currentQuizCount + count;

  updateQuizCount(queryClient, newQuizCount);
}
